<div class="text-sm mb-2">Update the status of this item</div>

<div class="mb-2 flex flex-row">
    <div class="flex-1 border-b-2"></div>
</div>

<div class="mb-2">
    <app-status-button-group [value]="defectStatusValue" />
</div>

<app-comments-text-editor #textEditor [placeholder]="'Add a comment or attach a photo...'" />

<!-- IMAGES -->
<div class="mt-2 p-2 rounded bg-neutral-50">
    <div class="w-full flex flex-row justify-start items-center">
        <!-- ATTACH BUTTON -->
        <p-fileUpload mode="basic" chooseLabel="Attach Photos" #uploaderToolTwo [showUploadButton]="false" [auto]="true"
            [disabled]="photos.length === 3" [showCancelButton]="false" name="myfile[]" [multiple]="true"
            [customUpload]="true" accept="image/*" (onSelect)="selectCommentImages($event, uploaderToolTwo);"
            chooseStyleClass="p-button-sm p-button-info"></p-fileUpload>
        <div class="pl-2 text-sm">({{photos.length}} / 3)</div>
    </div>

    @if (photos.length > 0) {
    <!-- IMAGE ROW -->
    <div class="mt-2 flex flex-row gap-2 overflow-x-auto">
        @for (item of photos; track $index; let i = $index) {
        <app-image-attachment [fullPath]="item.base64" [index]="i" [enablePreview]="false" autofocus
            (onDelete)="deletePhoto(i)"></app-image-attachment>
        }
    </div>
    }
</div>

<div class="py-4 w-full flex flex-row justify-end">
    <p-button class="mr-2" label="Cancel" severity="info" [disabled]="saving()" (click)="dismiss()"></p-button>
    <p-button label="Update" [loading]="saving()" [disabled]="photos.length === 0 && textEditor?.text === ''"
        (click)="save()"></p-button>
</div>